export interface IJobStatusSummaryItemArgs {
    jobStatus: string;
    title: string;
    count: number;
    sequence: number;
}

const defaults = () => ({
    jobStatus: "",
    title: "",
    count: 0,
    sequence: 0
});

export class JobStatusSummaryItem {
    jobStatus: string;
    title: string;
    count: number;
    sequence: number;

    constructor(data?: IJobStatusSummaryItemArgs) {
        data = {...defaults(), ...data};

        Object.keys(data).forEach(key => {
            this[key] = data[key];
        });
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/job-status-summary-item/job-status-summary-item.model.ts